module.exports = __webpack_public_path__ + "static/media/1701280251347.282c66e4.jpeg";